import React from 'react';
import { TabProps, Tab } from '@material-ui/core';

interface TabWithSubHeaderProps extends TabProps {
  openSubMenu?: boolean;
  subMenu?: React.ReactNode;
}

const TabWithSubHeader: React.FC<TabWithSubHeaderProps> = ({
  openSubMenu,
  subMenu,
  ...rest
}: TabWithSubHeaderProps) => {
  return (
    <div>
      <Tab {...rest} />
      {subMenu}
    </div>
  );
};

export default TabWithSubHeader;
